<template>
  <IconLucideCalendarX2 />
</template>
